import React from "react";
import { IRecentInquiries } from "../../../../store/credit/types";
import { getFormattedDate } from "../../../../util/dateFormatting";
import i18nService from "../../../../util/Internationalization/i18n/i18n";
interface IProps {
    data?: IRecentInquiries[];
}
const PrintCreditHistoryRecentInquiriesSingle: React.FunctionComponent<IProps> = (props) => {
    return (
        <React.Fragment>
            {props.data != null && props.data.length > 0 ? (
                <React.Fragment>
                    <h4 className=" margin-vertical-s">{props.data[0].bureau}</h4>
                    <div className="table-container scroll">
                        <table className="m-table-generic">
                            <thead>
                                <tr>
                                    <th scope="col">Requestor</th>
                                    <th scope="col">Date Requested</th>
                                    <th scope="col">Type</th>
                                </tr>
                            </thead>
                            <tbody>
                                {props.data.map((inquiry) => (
                                    <tr key={inquiry.index}>
                                        <td>{inquiry.requestor}</td>
                                        <td>{inquiry["date-requested"] && getFormattedDate(i18nService.get("Country"), inquiry["date-requested"])}</td>
                                        <td>{inquiry["inquery-type"]}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </React.Fragment>
            ) : (
                ""
            )}
        </React.Fragment>
    );
};

export default PrintCreditHistoryRecentInquiriesSingle;
